// @flow
import React, { Fragment, type Node } from 'react';

import Painted from './Painted';
import ApplyDescription from './ApplyDescription';
import getPaintByValue from './getPaintByValue';


type Props = {
  value: string,
  description: ?string,
  tail?: Node,
}

const Mark = ({ value, description, tail }: Props): Node => {
  const doubleMark = value.split('/');
  const isDoubleMark = doubleMark.length > 1;
  const paint = getPaintByValue(value);

  return (
    <Fragment>
      <ApplyDescription description={description} paint={paint}>
        {isDoubleMark
          ? <Fragment>
            <Painted paint={paint}>{doubleMark[0]}</Painted>
            {'/'}
            <Painted paint={paint}>{doubleMark[1]}</Painted>
          </Fragment>
          : <Painted paint={paint}>{value}</Painted>}
      </ApplyDescription>

      {tail && ', '}
    </Fragment>
  );
};

export default Mark;
